import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Dropdown } from 'primereact/dropdown';

import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import { useCaseStageList } from 'hooks/useCaseStageList';

const assignToItemTemplate = (option) => {
  if (option?.status === 'ARCHIVED') {
    return `${option?.stage_name} (Archived)`;
  }
  return option?.stage_name;
};

const CaseStageFilter = ({ index }) => {
  const { caseStageList, isStagesLoading } = useCaseStageList();
  const {
    formState: { errors },
    control,
    watch,
  } = useFormContext();

  const from = watch(`filters.${index}.from`);
  const to = watch(`filters.${index}.to`);

  const updatedOption = [{ sk: 'any', stage_name: 'Any' }, ...caseStageList];

  return (
    <>
      <div className="me-2 filterbar-condition d-none">
        <Controller
          name={`filters.${index}.from`}
          control={control}
          defaultValue={'any'}
          rules={{ required: 'Value is required' }}
          render={({ field }) => (
            <Dropdown
              options={updatedOption}
              value={field.value}
              onChange={(e) => field.onChange(e.value)}
              placeholder="To"
              isFilter={true}
              className="input-shadow w-100"
              optionLabel="stage_name"
              optionValue="sk"
              itemTemplate={assignToItemTemplate}
              dropdownIcon={isStagesLoading ? 'pi pi-spin pi-spinner' : undefined}
              optionDisabled={(index) => index.sk === to && index.sk !== 'any'}
              inputRef={field.ref}
            />
          )}
        />
        <RequiredValidation field={`filters.${index}.from`} errors={errors} />
      </div>
      <div className="me-2 filterbar-value">
        <Controller
          name={`filters.${index}.to`}
          control={control}
          rules={{ required: 'Value is required' }}
          render={({ field }) => (
            <Dropdown
              options={updatedOption}
              value={field.value}
              onChange={(e) => field.onChange(e.value)}
              placeholder="To"
              isFilter={true}
              className="input-shadow w-100"
              optionLabel="stage_name"
              optionValue="sk"
              itemTemplate={assignToItemTemplate}
              dropdownIcon={isStagesLoading ? 'pi pi-spin pi-spinner' : undefined}
              optionDisabled={(index) => index.sk === from && index.sk !== 'any'}
              inputRef={field.ref}
            />
          )}
        />
        <RequiredValidation field={`filters.${index}.to`} errors={errors} />
      </div>
    </>
  );
};

export default CaseStageFilter;
